module.exports = __webpack_public_path__ + "img/gy.8993c26d.svg";